import { render, staticRenderFns } from "./BlogIndex.vue?vue&type=template&id=1f044e0a"
import script from "./BlogIndex.vue?vue&type=script&lang=js"
export * from "./BlogIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports